import { FC } from 'react';
import { UserMenuView } from './UserMenu.view';
import { useAuthSlice } from '@restore/auth/auth.slice';

interface UserMenuProps {
  useAttributes?: boolean;
}

export const UserMenu: FC<UserMenuProps> = ({
  useAttributes,
}) => {
  const userData = useAuthSlice(s => s.data);

  return (
    <UserMenuView
      useAttributes={useAttributes}
      authUser={userData}
    />
  );
};
